
$(document).ready((): void => {
  $(".tip").tooltipster({ contentAsHTML: true });

  if ($("#air_bad_error").length > 0) {
    setTimeout(function() {
      $.fancybox.open($("#air_bad_error"));
    }, 250);
  }

  // BookingWidgets.load_car_widget();
  // BookingWidgets.load_hotel_widget();
  // BookingWidgets.load_car_widget_actions();
});
